
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Image } from '@ta-interaktiv/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h4>Die Fussfessel schaltet sich aus</h4>
    <p>
  Anfangs 2017 hat William W. zum dritten Mal im Leben die Möglichkeit, es besser zu machen. Er geniesst seine
  zurückerlangte Freiheit offensichtlich. Auf Facebook präsentiert er sich mit gestähltem Oberkörper beim
  Fitnesstraining und im Ausgang an einem Konzert. Und er lotet die Grenzen aus. Eigentlich sollte der
  Wiederholungstäter im geschützten Wohnheim übernachten. Doch die Behörden erfahren, dass er täglich bei einer Freundin
  schläft. Diese wohne «in unmittelbarer Nähe zu einem Primarschulhaus», warnen sie laut Untersuchungsbericht. Zudem
  habe W. sein GPS-Überwachungsgerät nicht richtig aufgeladen, «weshalb sich dieses ausgeschaltet habe». Umgehend droht
  das Amt: Die ambulante Massnahme in Freiheit werde aufgehoben, falls der 43-Jährige weiterhin gegen die Auflagen
  verstosse. Es ist die erste einer ganzen Serie von Ermahnungen, die ohne Folgen bleiben.
    </p>
    <Image file={require('images/freizeit.png')} source='W. geniesst die Freiheit. (Facebook)' mdxType="Image" />
    <p>
  Bereits acht Wochen später schlägt die Solothurner Bewährungshilfe Alarm. Seit drei Tagen haben die Behörden kein
  GPS-Signal von der Fussfessel bekommen. Und William W. in dieser Zeit nicht überwachen können. Dessen Begründung?
  Wegen einem RAV-Kurs und der Arbeitssuche sei er derart im Stress gewesen, dass er das Gerät vergessen habe.
  Konsequenzen bleiben laut Untersuchungsbericht aus: «Die Vollzugsbehörde liess es vorerst bei einer erneuten Mahnung
  bewenden.»
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;